import { Component, OnInit, ViewChild } from '@angular/core';
import { MdDialogRef, MdOptionSelectionChange, DateAdapter } from '@angular/material';

import * as moment from 'moment';

@Component({
  selector: 'repetir-subdialog-component',
  templateUrl: './repetir-subdialog.component.html',
  styleUrls: ['./repetir-subdialog.component.scss']
})
export class RepetirSubDialogComponent implements OnInit {

  mode: string = 'DAILY';
  months = [];
  weekdays = [];
  shortweekdays = [];
  positions = [];

  month:string = '';
  day:string = '';
  position:string = '';
  interval1: string = '';
  interval2: string = '';

  errors:boolean = false;

  model:any = {};

  constructor(public dialogRef: MdDialogRef<RepetirSubDialogComponent>) {
    
  }

  ngOnInit() {
    this.loadSelectsOptionsAndModel();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  changedRepetirOptions(e) {
    this.interval1 = '';
    this.interval2 = '';
    this.month = '';
    this.day = '';
    this.position = '';
  }

  loadSelectsOptionsAndModel() {
    this.months = Array.from(Array(10).keys()).map(m => ({label: moment().month(m).format('MMMM'), value: m}));
    this.weekdays = Array.from(Array(7).keys()).map(d => ({label: moment().day(d).format('dddd'), value: d}));
    this.shortweekdays = Array.from(Array(7).keys()).map(d => ({label: moment().day(d).format('ddd'), value: d, model: false}));

    this.positions = [
      {
        label: 'primer',
        value: 'FIRST'
      }, 
      {
        label: 'segundo',
        value: 'SECOND'
      },
      {
        label: 'tercer',
        value: 'THIRD'
      },
      {
        label: 'cuarto',
        value: 'FOURTH'
      },
      {
        label: 'último',
        value: 'LAST'
      }
    ];

    // load model
    if (this.model.mode) {
      this.mode = this.model.mode;
      this.interval1 = this.model.interval1;
      this.interval2 = this.model.interval2;
      this.day = this.model.day;
      this.month = this.model.month;
      this.position = this.model.position;
      this.shortweekdays = this.shortweekdays.map((d,i) => ({...d, model: this.model.shortweekdays[i].model}));
    }
  }

  onSubmit() {
    this.errors = false;

    if (this.mode === 'DAILY') {
      this.errors = this.interval1.length <= 0 || isNaN(Number(this.interval1)) || Number(this.interval1) <= 0;
    } else if (this.mode === 'WEEKLY') {
      this.errors = this.interval1.length <= 0 || isNaN(Number(this.interval1)) || this.shortweekdays.filter(d => d.model).length <= 0 || Number(this.interval1) <= 0;
    } else if (this.mode === 'MONTHLY') {
      this.errors = this.interval1.length <= 0 || isNaN(Number(this.interval1)) || this.interval2.length <= 0 || isNaN(Number(this.interval2)) || Number(this.interval2) <= 0 || Number(this.interval1) < 1 || Number(this.interval1) > 31;
    } else if (this.mode === 'WEEKLY2') {
      this.errors = this.interval1.length <= 0 || isNaN(Number(this.interval1)) || this.day.length <= 0 || this.position.length <= 0 || Number(this.interval1) <= 0;
    } else if (this.mode === 'YEARLY') {
      this.errors = this.interval1.length <= 0 || isNaN(Number(this.interval1)) || this.month.length <= 0 || Number(this.interval1) < 1 || Number(this.interval1) > 31;
    } else if (this.mode === 'YEARLY2') {
      this.errors = this.position.length <= 0 || this.day.length <= 0 || this.month.length <= 0;
    }

    if (this.errors) {
      return;
    }

    this.dialogRef.close({
      mode: this.mode,
      interval1: this.interval1,
      interval2: this.interval2,
      day: this.day,
      month: this.month,
      position: this.position,
      shortweekdays: this.shortweekdays
    });
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agenda/new-consigna-dialog/repetir-subdialog.component.ts